import { TimeUtils } from "@front/volcanion/utils"
import _ from "lodash"
import moment from "moment"

const HALF_DAY_HOURS = 12
const DAY_HOURS = 24

const getDurations = (options, duration, isManagingRecord) => {
  return _.orderBy(_.flatten([
    options,
    _.compact([!!isManagingRecord && { label: TimeUtils.secondsToTime(duration, 'HH[h]mm[min]'), value: duration }])
  ]), ['value'], ['asc'])
}

const getNumberOfNight = (departurePickedAt, returnDropoffAt) => {
  const total_stay_duration = moment.utc(returnDropoffAt).diff(moment.utc(departurePickedAt), 'hours', true)
  const night = _.floor((total_stay_duration + HALF_DAY_HOURS) / DAY_HOURS)
  return _.max([0, night])
}


const Aux = {
  getDurations,
  getNumberOfNight
}

export default Aux
